export default __webpack_public_path__ + "static/media/do.c7a3829f.svg";